// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Stack, PrimaryButton, IIconProps } from "@fluentui/react";
import { ErrorCircle24Regular } from "@fluentui/react-icons";

import styles from "./Answer.module.css";

interface Props {
    error: string;
    onRetry?: () => void;
    useDarkMode: boolean;
};

export const AnswerError = ({ error, onRetry, useDarkMode }: Props) => {
    return (
        <Stack className={useDarkMode ? styles.answerContainerDark : styles.answerContainer} verticalAlign="space-between">
            <ErrorCircle24Regular aria-hidden="true" aria-label="Error icon" primaryFill="red" />

            <Stack.Item grow>
                <p className={styles.answerTextError}>{error}</p>
            </Stack.Item>

            {onRetry && (
                <PrimaryButton
                    iconProps={{ iconName: 'Refresh' }}
                    className={styles.retryButton}
                    onClick={onRetry}
                    text="Retry"
                />
            )}
        </Stack>
    );
};